<template>
  <div class="login_bg">
    <div class="login_logo" @click="toIndex"><img src="@/assets/images/login_logo@2x.png" height="55" /></div>
    <slot></slot>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
export default {
  name: 'landing',
  methods: {
    ...mapActions('auth', ['getBusinessIdByCode', 'toOtherDomain']),
    toIndex () {
      this.$router.push({ path: '/reload' })
    }
  }
}
</script>
<style lang="scss">
  .login_bg {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    background:url(../../assets/images/login_bg.jpg) center center no-repeat;
    background-size: 100%;
    z-index: 0;
    overflow:hidden; word-break:break-all;
  }
  .login_logo{ position:absolute;top:10px;left:5%; cursor: pointer}
</style>



// WEBPACK FOOTER //
// src/page/byl/landing.vue